<template>
  <vs-input
    v-uppercase
    icon-pack="feather"
    icon="icon-phone"
    v-model="model"
    class="w-full bg-white"
    v-mask="['(##) ####-####', '(##) #####-####']"
    :name="name"
    @input="$emit('input', model)"
  ></vs-input>
</template>

<script>
export default {
  name: "telefone-input",
  props: ["value", "name"],
  data: () => {
    return {
      model: null
    };
  },
  created() {
    this.model = this.value;
  },
  watch: {
    value(value) {
      this.model = value;
    }
  }
};
</script>
